<template>
  <div class="index">
      <p class="welcome">欢迎进入健康管理云平台</p>
      <div class="img" v-for="(item,index) in msg.rights" :key="index" @click="nextPage(item.right_code,item.member_right_id)" >
          <img src="../assets/图片1.png" alt="" v-if="item.right_code == 'HPV'">
          <img src="../assets/图片2.png" alt="" v-else-if="item.right_code == 'GREEN_CHANNEL'">
          <p v-if="item.right_code == 'HPV'">在线预约HPV疫苗</p>
          <p v-if="item.right_code == 'GREEN_CHANNEL'">在线预约门诊就医</p>
          <span>立即预约 >></span>
      </div>
      <div class="empty" v-if="msg.rights.length == 0">
        <span>您暂时没有可用权益</span>
      </div>
      <p class="phoneNum">
        咨询热线：4000685099
      </p>
      <footer class="footer">
        <ul>
            <router-link to="/index" tag="li" class="tj">
            <img v-if="ind==1" src="../assets/index1.png" alt="">
            <img v-else src="../assets/index2.png" alt="">
            <em :class="{active:ind==1}">首页</em>
            </router-link>
            <router-link to="/order" tag="li" class="zx">
            <img v-if="ind==2" src="../assets/记录1.png" alt="">
            <img v-else src="../assets/记录2.png" alt="">
            <em>预约记录</em>
            </router-link>
        </ul>
      </footer>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      ind: 1,
      msg: ""
    };
  },
  created() {
    let _this = this;
    axios.get(HPV_URL + "/api/rights/").then(res => {
      console.log(res.data);
      this.msg = res.data;
    });
  },
  methods: {
    nextPage(code, id) {
      sessionStorage.setItem("member_id", id);
      console.log(code, id);
      if (code == "HPV") {
        this.$router.push({
          path: "/reserve",
          query: {
            id: id
          }
        });
      } else if (code == "GREEN_CHANNEL") {
        this.$router.push({
          path: "/hospital",
          query: {
            id: id
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.welcome {
  font-size: 20px;
  text-align: center;
  margin: 35px 0;
  font-weight: 500;
}
.phoneNum{
  text-align: center;
  font-size: 16px;
  margin-top: 40px;
}
.empty{
  text-align: center;
  font-size: 16px
}
.img {
  margin: 0 15px;
  position: relative;
  margin-bottom: 20px;
}
.img img {
  width: 100%;
}
.img p {
  position: absolute;
  left: 10.67%;
  top: 31px;
  font-size: 20px;
  color: #fff;
}
.img span {
  font-size: 16px;
  color: #fff;
  position: absolute;
  top: 66px;
  left: 10.67%;
}
.footer {
  width: 100%;
  height: 55px;
  position: fixed;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 1);
  border-top: 1px solid #dfdfdf;
}
.footer ul {
  width: 100%;
  height: 55px;
  display: flex;
}
.footer ul li {
  width: 50%;
  height: 55px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer ul li img {
  width: 30px;
  height: 22px;
  margin-top: 8px;
}
.footer ul .xz img {
  width: 17px;
  height: 21px;
}
.footer ul .tj img {
  width: 22px;
  height: 21px;
}
.footer ul .zx img {
  width: 20px;
  height: 21px;
}
.footer ul li em {
  margin-top: 3px;
}
.footer ul li .active {
  color: #e24709;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue